import { IBarcodeWithExtraProps } from 'Services/Kiosk/BarcodeService'
import { Input } from 'antd'

export default function PublicBarcodeCell({
  barcode,
  isEditMode,
  onBarcodeChanged,
}: {
  barcode: IBarcodeWithExtraProps
  isEditMode: boolean
  onBarcodeChanged: (sizename: string, originalBarcode: string, newBarcode: string) => void
}) {
  function handleChangeBarcode(sizename: string, originalBarcode: string, newBarcode: string) {
    onBarcodeChanged(sizename, originalBarcode, newBarcode)
  }

  if (barcode) {
    return isEditMode ? (
      <Input
        className='barcode-edit'
        defaultValue={barcode.value}
        onChange={e => handleChangeBarcode(barcode.size.sizeName, barcode.originalValue, e.target.value)}
      />
    ) : (
      <span>{barcode.value}</span>
    )
  }

  return null
}
